import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AssetResponse } from '../../../core/models/asset.model';
import { HandoffResponse } from '../../../core/models/handoff.model';
import { ChatMessage } from '../../../core/models/chat-message.model';
import { Session, SessionInputPayload, Phase } from '../../../core/models/session.model';
import { SlidePreview } from '../../../core/models/slide-preview.model';
import { WsUserMessage } from '../../../core/models/websocket-message.model';

export const SessionActions = createActionGroup({
  source: 'Session',
  events: {
    'Create Session': props<{ s3HandoffKey: string }>(),
    'Create Session Success': props<{ session: Session }>(),
    'Create Session Failure': props<{ error: string }>(),

    'Submit Input': props<{ sessionId: string; payload: SessionInputPayload }>(),
    'Submit Input Success': props<{ sessionId: string }>(),
    'Submit Input Failure': props<{ error: string }>(),

    'Upload Logo': props<{ sessionId: string; file: File }>(),
    'Upload Logo Success': props<{ asset: AssetResponse }>(),
    'Upload Logo Failure': props<{ error: string }>(),

    'Load Handoff Success': props<{ handoff: HandoffResponse }>(),

    'Websocket Connected': emptyProps(),
    'Websocket Disconnected': emptyProps(),
    'Websocket Reconnecting': emptyProps(),

    'Message Sent': props<{ message: WsUserMessage }>(),
    'Message Received': props<{ message: ChatMessage }>(),
    'Preview Received': props<{ slides: ReadonlyArray<SlidePreview>; totalSlides: number; deckVersion: number }>(),
    'Phase Changed': props<{ phase: Phase }>(),
    'Export Ready': props<{ downloadUrl: string; fileName: string; expiresAt: string }>(),
    'Error Received': props<{ message: string; retryAvailable: boolean }>(),

    'Hydrate Session': props<{ sessionId: string }>(),
    'Hydrate Session Success': props<{ session: Session; messages: ReadonlyArray<ChatMessage>; slides: ReadonlyArray<SlidePreview>; handoff: HandoffResponse | null }>(),
    'Hydrate Session Failure': props<{ error: string }>(),

    'Restore Local State': props<{ userInput: SessionInputPayload | null; logoUrl: string | null }>(),
  },
});
